import * as React from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import hasFeature from 'modules/core/lib/hasFeature'

import KomboSupplementSyncStatus from 'modules/payroll_integrations_kombo/components/SupplementSyncStatus'
import CompanyInstallationsChecker from 'modules/payroll_integrations_kombo/lib/CompanyInstallations/checker'
import {
  IntegrationLabels,
  IntegrationTools,
} from 'modules/payroll_integrations_kombo/lib/constants'

interface Props {
  supplementId: number
  policyPeriodId: number
  policyPeriodStatus: string
  hover: boolean
}

const SupplementSyncStatus = ({
  supplementId,
  policyPeriodId,
  policyPeriodStatus,
  hover,
}: Props) => {
  const [installed, setInstalled] = React.useState(false)

  useAsyncData(async () => {
    const silaeInstalled = await CompanyInstallationsChecker.isSilaeApiInstalled()

    setInstalled(silaeInstalled)
  }, [])

  return (
    <>
      {installed && hasFeature('dev_silae_api_supplements') && (
        <KomboSupplementSyncStatus
          key={IntegrationTools.silae + supplementId}
          supplementId={supplementId}
          policyPeriodId={policyPeriodId}
          policyPeriodStatus={policyPeriodStatus}
          integrationTool={IntegrationTools.silae}
          integrationLabel={IntegrationLabels.silae}
          hover={hover}
        />
      )}
    </>
  )
}

export default SupplementSyncStatus
